import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Input, Form, Button, Icon, Alert } from 'antd'
import { withRouter } from 'react-router-dom'
import './login.less'
import './authorize.less'
import * as actions from '../actions'
import * as API from '../services/api'
import { compose } from '../common/utils'
import { notifySuccess } from '../common/notification'

class Login extends React.Component {
  state = {
    errMsg: null,
    isSubmitting: false
  };

  handleSubmit = e => {
    if (e) e.preventDefault()

    this.props.form.validateFieldsAndScroll((err, values) => {
      if (err) return
      this.setState({
        errMsg: null,
        isSubmitting: true
      })
      // login api call
      return API.login(values.username, values.password).then(
        res => {
          this.setState({ isSubmitting: false })
          this.props.setUserInfo({})
          notifySuccess('Successfully signed in. Welcome back.')
          setTimeout(() => {
            this.props.history.push('/estimate')
          }, 1000)
        },
        e => {
          this.setState({
            errMsg: e.message,
            isSubmitting: false
          })
        }
      )
    })
  };

  componentDidMount () {
    document.getElementById('root').className = 'lights-on'
  }

  componentWillUnmount () {
    document.getElementById('root').className = ''
  }

  render () {
    const { errMsg } = this.state

    return (
      <div className="login-container">
        <div className="login-inner">
          <div className="image logo">
            <img src="synkedup-light.png" alt="Synkedup logo" />
          </div>

          <h2>
            {process.env.NODE_ENV === 'production'
              ? 'Login'
              : 'Test Login'}
          </h2>

          {errMsg && errMsg.length ? (
            <div className="error-message">
              <Alert message={errMsg} type="error" showIcon />
            </div>
          ) : (
            ''
          )}

          <Form onSubmit={this.handleSubmit} className="login-form">
            <Form.Item hasFeedback rules={[{ required: true, message: 'Please input your username' }]}>
              <Input
                prefix={<Icon type="user" style={{ fontSize: 13 }} />}
                placeholder="Username"
              />
            </Form.Item>
            <Form.Item hasFeedback rules={[{ required: true, message: 'Please input your Password' }]}>
              <Input
                prefix={<Icon type="lock" style={{ fontSize: 13 }} />}
                type="password"
                placeholder="Password"
              />
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button"
                loading={this.state.isSubmitting}
              >
                Log in
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    )
  }
}

export default compose(
  connect(
    state => ({ route: state.route }),
    dispatch => bindActionCreators({ ...actions }, dispatch)
  ),
  withRouter
)(Login)
